/*!
 * isobject <https://github.com/jonschlinkert/isobject>
 *
 * Copyright (c) 2014-2015, Jon Schlinkert.
 * Licensed under the MIT License.
 */

'use strict';

var isArray = require('isarray');

module.exports = function isObject(val) {
  return val != null && typeof val === 'object' && isArray(val) === false;
};



/*****************
 ** WEBPACK FOOTER
 ** ./~/isobject/index.js
 ** module id = 66
 ** module chunks = 0
 **/